module.exports = __webpack_public_path__ + "static/media/Mariman Homes Receivership Case.64d92898.pdf";